import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Icon from '@afosto/app-components-react/Icon';

const PositionCard = ({ onClick, position }) => (
  <>
    <Card>
      <CardActionArea onClick={onClick}>
        <CardContent component="div" style={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            component="div"
            variant="h6"
            color={position ? 'textPrimary' : 'error'}
            style={{ flex: 1 }}
          >
            {position || 'Geen'}
          </Typography>
          {onClick && <Icon icon={['fal', 'pencil']} size="small" />}
        </CardContent>
      </CardActionArea>
    </Card>
  </>
);

PositionCard.propTypes = {
  onClick: PropTypes.func,
  position: PropTypes.string,
};

PositionCard.defaultProps = {
  onClick: undefined,
  position: undefined,
};

export default PositionCard;
